import MaterialDepositoryService from '../../service/MaterialDepository.service.js'
import { Notification } from 'element-ui';
export class Material {
  list = null;
  total = 0;
  srcList = []
  constructor(params) {
    this.getList(params)
  }

  async getList(params) {
    const res = await MaterialDepositoryService.getList(params)
    this.list = res.results.map(item => {
      item.is_edit = false
      item.is_show = false
      item.url = item.url
      return item
    })
    this.srcList = res.results.map(item => {
      return item.url + '?x-oss-process=style/middle'
    })
    this.total = res.count
  }

  editTitle(imgData) {
    this.list.forEach((item) => {
      if (item.id !== imgData.id) item.is_edit = false;
    });
    if (imgData.is_edit) {
      if (imgData.title === "") {
        Notification({
          title: "提示",
          message: "图片名称不得为空！",
          type: 'warning'
        });
      } else {
        MaterialDepositoryService.edit(imgData).then(res => {
          Notification({
            title: "成功",
            message: "图片标题已修改",
            type: "success"
          });
          imgData.is_edit = false
        })
      }
    } else {
      imgData.is_edit = true
    }
  }

  del(imgData, index) {
    MaterialDepositoryService.del(imgData).then(res => {
      Notification({
        title: "成功",
        message: "图片已删除",
        type: "success"
      });
      this.list.splice(index, 1)
    })
  }
}